/**
 * Public asset paths (from public/). Use these instead of hardcoding paths.
 */

const base = {
  images: '/assets/images',
  svg: '/assets/svg',
};

/** Raster images (png, jpg) */
export const images = {
  logo: `${base.images}/logo.png`,
  whiteLogo: `${base.images}/white_logo.jpg`,
  women: `${base.images}/women.jpg`,
  twitter: `${base.images}/twiter.png`,
};

/** SVG assets */
export const svg = {
  star: `${base.svg}/star.svg`,
  underline: `${base.svg}/underline.svg`,
  chartLine: `${base.svg}/chart-line.svg`,
  book: `${base.svg}/book.svg`,
  arrowRight: `${base.svg}/arrow-right.svg`,
  arrowLeft: `${base.svg}/arrow-left.svg`,
  checkmark: `${base.svg}/checkmark.svg`,
  checkmarkThick: `${base.svg}/checkmark-thick.svg`,
  chevronDown: `${base.svg}/chevron-down.svg`,
  quote: `${base.svg}/quote.svg`,
  facebook: `${base.svg}/facebook.svg`,
  // twitter: `${base.svg}/twitter.svg`,
  instagram: `${base.svg}/instagram.svg`,
  email: `${base.svg}/email.svg`,
  phone: `${base.svg}/phone.svg`,
  whatsapp: `${base.svg}/whatsapp.svg`,
};

/** Single export for all image paths (images + svg) */
const allImages = {
  ...images,
  ...svg,
};
export default allImages;
